"use client";

/**
 * A page whose server data failed and has no earlier copy to serve: the app's own
 * message, with a retry that renders the route again.
 */
export default function RouteError({ reset }: { reset: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 text-center">
      <div>
        <h1 className="mb-4 text-2xl font-bold text-ink-black">
          Something went wrong
        </h1>
        <p className="mb-6 text-ink-secondary">
          We couldn&apos;t load this page. Please try again.
        </p>
        <button
          type="button"
          onClick={reset}
          className="rounded-lg bg-coral-pink-500 px-6 py-2 font-medium text-white transition-colors hover:bg-coral-pink-600"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
